/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ControlPanelType {
    Unknown = 0,
    Annotation = 1,
    Checklist = 2,
    Assessment = 3,
    Announcement = 4,
    Microphone = 5,
    Transmission = 6,
    Audience = 7,
    MediaScreens = 8,
    MediaLibrary = 9,
    TrainTheTrainer = 10,
    Operator = 11,
    VoiceOfPatient = 12,
    Export = 13,
    AudioChannels = 14,
    ViewManagement = 15,
    Room = 16,
    EventSelection = 17,
}
